<template lang="html">
  <section class="flex-center-col">
    <button
    @click="selectMode(true)"
    :class="mode ? 'active' : null" style="display: none;"
    >שחקן יחיד</button>
<!--    <button
    @click="selectMode(false)"
    :class="!mode ? 'active' : null"
    >הרבה שחקנים</button>-->
    <input type="text"  style="direction:rtl;direction:rtl;fontSize:30px" v-model="playerName" placeholder="הכנס שם" >
    <button @click="startGame">התחל</button>
    <div>
      <table class="table table-striped" style="direction:rtl;fontSize:50px;border: 10px black !important;" >
        <th style="width:120px"> שם שחקן </th>
        <th style="width:50px">תוצאה  </th>
        <th style="width:250px" > תאריך משחק </th>
        <tr v-for="player in playersList"   style="direction:rtl;fontSize:50px;border: 10px honeydew !important ;color:honeydew;bold:bold;text-align:center">
          <td> {{player.playerName}}</td>
          <td> {{player.score}}</td>
          <td style="width:400px;fontSize:30px;">{{new Date(player.time).toLocaleTimeString() +'  '+new Date(player.time).toLocaleDateString() }}  </td>
        </tr>
      </table>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      playersList:[],
      dropdownClass: {
        close: false,
        open: false,
      },
      toggleExpand: true, // toggles expand icons
      playerName:''
    }
  },
  computed: {
    aboutShow() {
      return this.$store.state.aboutShow;
    },
    categories() {
      // Return categories from state
      return this.$store.state.categories;
    },
    currentCategory() {
      return this.$store.state.currentCategory;
    },
    mode() {
      // Return mode from state. Used to determine selected button style.
      return this.$store.state.solo;
    }
  },
  methods: {
    // Send category data to store, set selected category
    chooseCategory(category) {
      this.$store.commit('setCurrentCategory', category);
    },
    // Toggle animation/display classes for category list
    dropdownToggle() {
      this.toggleExpand = !this.toggleExpand;
      if (this.dropdownClass.open) {
        this.dropdownClass.open = false;
        this.dropdownClass.close = true;
      } else {
        this.dropdownClass.open = true;
        this.dropdownClass.close = false;
      }
    },
    // Call selectMode mutation
    selectMode(mode) {
      this.$store.commit('selectMode', mode);
    },
    startGame() {
      this.$store.commit('playerName', this.playerName);
      console.log(this.playerName)
      this.$store.dispatch('startGame');
      // Close About menu if open
      if (this.aboutShow) {
        this.$store.commit('aboutToggle');
      }
    },
  },
  created(){

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
      referrerPolicy: "no-referrer-when-downgrade"
    };
    let that = this ;

    fetch("https://trivia.voicenter-ltd.workers.dev/", requestOptions)
        .then(response => response.text())
        .then(result =>{
          console.log(result);
          let resultObj =  JSON.parse(result);
          if(resultObj.PlayerList)that.playersList=resultObj.PlayerList
          that.playersList.sort((a, b) => {
            return b.score - a.score;
          });
          this.$store.commit('playersList',   that.playersList);
        })
        .catch(error => console.error('error', error));

  }
}
</script>

<style lang="scss" scoped>@import ".././main.scss";
@media (max-width: 600px) {
    section {
        padding: 0 2.5%;
    }
}

.expand-less,
.expand-more,
h2,
li {
    cursor: pointer;
}

h3 {
    color: $color-white;
    margin: 0;
}

li {
    margin: 0.5em 0;
    transition: all 0.3s ease;
    &:hover {
        color: $color-white;
        //font-size: 1.5em;
        transform: scale(1.5);
    }
}

ul {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
}

// Selected mode button
.active {
    background-color: $color-darkest;
    border: 2px solid $color-darkest;
    color: $color-white;
}

.dropdown-label {
    align-items: center;
    display: flex;
    justify-content: center;
}

// Category dropdown expand icon
.expand-less,
.expand-more {
    font-size: 2em;
    padding-top: 7px;
    margin-left: 15px;
    transition: all 0.3s ease;
}

.expand-more {
    color: $color-white;
    &:hover {
        color: $color-darkest;
    }
}

.expand-less {
    color: $color-darkest;
    &:hover {
        color: $color-white;
    }
}

// Open dropdown
.open {
    animation: open 1s ease forwards;
}

// Close dropdown
.close {
    animation: close 1s ease forwards;
}
</style>



// WEBPACK FOOTER //
// Starter.vue?63a4a982